import { render, staticRenderFns } from "./rotatingAdvertisement.vue?vue&type=template&id=c7bc549a&scoped=true"
import script from "./rotatingAdvertisement.vue?vue&type=script&lang=js"
export * from "./rotatingAdvertisement.vue?vue&type=script&lang=js"
import style0 from "./rotatingAdvertisement.vue?vue&type=style&index=0&id=c7bc549a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bc549a",
  null
  
)

export default component.exports